import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { r as retry, g as GoogleService } from './index2.js';
import { d as defineCustomElement$3 } from './roche-button2.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

const rocheSingleSignInCss = "roche-single-sign-in>.center{display:flex;justify-content:center;align-items:center;flex-direction:column}";
const RocheSingleSignInStyle0 = rocheSingleSignInCss;

const RocheSingleSignIn$1 = /*@__PURE__*/ proxyCustomElement(class RocheSingleSignIn extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.componentDidLoad = () => {
            retry(GoogleService.initialize, 1000)
                .then(() => {
                // Show One Tap UI auto sign in
                GoogleService.showLoginPrompt();
                // Fallback button if One Tap UI was denied by user
                GoogleService.renderGoogleSignInButton(this.loginButton);
            });
        };
        this.debug = false;
    }
    render() {
        return (h("div", { key: '9392580ede75a90ef3b934ccff0aadf42e078ea1', class: "center" }, h("div", { key: '84b8724c2fd5731bb1dee011ec510cf7c51023ad', ref: (domElement) => { this.loginButton = domElement; } }), this.debug && (h("roche-button", { text: "Sign out", onRocheButtonClick: GoogleService.signOut }))));
    }
    static get style() { return RocheSingleSignInStyle0; }
}, [0, "roche-single-sign-in", {
        "debug": [4]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-single-sign-in", "roche-button", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-single-sign-in":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSingleSignIn$1);
            }
            break;
        case "roche-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheSingleSignIn = RocheSingleSignIn$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSingleSignIn, defineCustomElement };

//# sourceMappingURL=roche-single-sign-in.js.map